// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3SgDE","messages":"Chat_messages__R8rZ_","dateDivider":"Chat_dateDivider__3y4Po"};